﻿import { init as initAccordion } from "../../../src/accordion";

const c = {
	accHeader: ".ccs-cc-inline-acc-header",
};

export default function(ep, options) {
	initAccordion(ep, options);

	const $accHeader = ep.find(c.accHeader);

	ep.on("accordionOpen", () => $accHeader.html(`-${options.accordion.expandedText}`));
	ep.on("accordionClose", () => $accHeader.html(`+${options.accordion.collapsedText}`));
}